import {
  Component,
  ChangeDetectorRef,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ModalService} from '../../services/modal.service';
import {OrderService} from '../../services/order.service';
import {AuthService} from '../../services/auth.service';
import {TranslateService} from '../../services/translate.service';
import {LoadingSpinnerComponent} from '../ui/loading-spinner-component';
import {SnackbarService} from '../../services/snackbar.service';
import {DialogButtonComponent} from '../buttons/dialog-button.component';
import {AppStateService} from '../../services/app-state.service';
import {Subscription} from 'rxjs';
import { ConfigService } from '../../services/config.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, LoadingSpinnerComponent, DialogButtonComponent],
  template: `
    <div class="bg-theme-surface rounded-2xl shadow-xl max-w-lg w-80 relative">
      <div class="p-4">
        <div class="text-xl font-medium">Ange rumsnummer</div>
      </div>

      <div class="px-4 pt-6 pb-2 flex flex-col items-center">
        <input
          [disabled]="sending"
          #roomCodeInput
          [(ngModel)]="roomCode"
          [placeholder]="roomPlaceholder"
          type="text"
          class="w-40 p-2 border rounded-xl bg-theme-surface2 text-center uppercase focus:outline-none focus:ring-2 ring-theme-primary placeholder-theme-primary-50 font-medium text-lg tracking-wider"
          >
      </div>

      <div class="h-6">
        <div *ngIf="error && !sending" class="text-center">{{translate.getString("Felaktigt rumsnummer")}}</div>
      </div>
      <div *ngIf="sending" class="absolute bottom-10 left-0 right-0 w-full">
        <app-loading-spinner></app-loading-spinner>
      </div>

      <div class="px-4 pb-4 flex gap-2 justify-end">
        <app-dialog-button [text]="translate.getString('Stäng')" (onClick)="close()"></app-dialog-button>
        <app-dialog-button [text]="translate.getString('OK')" (onClick)="submitRoomCode()" variant="primary"></app-dialog-button>
      </div>
    </div>
  `
})
export class RoomCodeModalComponent implements OnInit, OnDestroy {
  roomCode = "";
  error = false;
  sending = false;
  lastTestedCode?: string;
  roomHint?: string;
  roomPlaceholder?: string;
  @ViewChild('roomCodeInput') roomCodeInput!: ElementRef<HTMLInputElement>;

  constructor(private modalService: ModalService, private order: OrderService,
              private auth: AuthService, protected translate: TranslateService,
              private cdr: ChangeDetectorRef, private snackbarService: SnackbarService, private config: ConfigService) { }

  ngOnInit() {
    console.log('Modal component initialized');
    /*
    this.roomHint = this.config.getText("room_hint");
    this.roomPlaceholder = this.config.getText("room_example", "RUM");*/
    this.roomHint = "Ange rumsnummer";
    this.roomPlaceholder = "RUM";

  }

  ngAfterViewInit() {
    this.roomCodeInput.nativeElement.focus();
  }

  ngOnDestroy() {
    console.log('Modal component destroyed');
  }

  
  submitRoomCode() {
    let room = this.roomCode.toUpperCase();
    /*if (room.length > 5) {
      room = room.substring(0, 5);
    }
    this.room = room;*/
    console.log(room);
    this.error = false;
    if (room) {
        this.sending = true;
        this.order.updateCollected(undefined, undefined, undefined, room).subscribe( r => {
          this.sending = false;
          this.close();
        }, error => {
            this.error = true;
            this.sending = false;
            this.cdr.detectChanges();
          throw error;
        });
    }

  }

  close() {
    this.modalService.close();
  }
}
